function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _objectSpread({
        viewBox: "0 0 25 24"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12.537",
                cy: "11.98",
                r: "10.853",
                stroke: "#EEF",
                strokeWidth: "1.55"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.228 13.487.757-8.63h-3.388l.757 8.63h1.874Zm-.919 4.127c.973 0 1.586-.631 1.586-1.55 0-.955-.613-1.586-1.586-1.586-.955 0-1.586.631-1.586 1.586 0 .919.631 1.55 1.586 1.55Z",
                fill: "#EEF"
            })
        ]
    }));
};
export default Icon;
